<header>{{ Localization.ChangeLanguage | translate }}</header>
<main class="languages">

    <a (click)="activate(language)"
       *ngFor="let language of availableLanguages"
       class="language">
        {{ 'language_' + language | translate }}
    </a>

</main>
